import { HttpParams } from '@angular/common/http';

export function BuildHttpParamsFromFilters<T extends { [key: string]: any }>(filters: Partial<T>) {
  let params = new HttpParams();
  for (const property in filters) {
    const prop = property as keyof typeof filters as string;
    const value = filters[prop];
    if (value === undefined) continue;
    if (typeof value === 'object' && value !== null) {
      params = params.appendAll({ [prop]: value });
    } else {
      value !== null && (params = params.append(prop, value.toString()));
    }
  }
  return params;
}
